module.exports = __webpack_public_path__ + "static/media/Inter-Medium.04e41bdd.woff";